<template>
    <div v-if="invalid == false" class="main_container">
      <h3>Loading...</h3>
      <p>Verifying your link...</p>
    </div>
    <div v-else class="main_container">
      <h3>Error</h3>
      <p>
        The link you followed is invalid or has expired. Please contact your
        representative for a new link.
      </p>
    </div>
  </template>
  
  <script>
  import $ from "jquery";
  import MyUtils from "@/utils/MyUtils";

  export default {
    name: "RenewalApplyLoading",
    components: {},
    props: {
      link: String,
    },
    data() {
      return {
        invalid: false,
      };
    },
    methods: {
      next() {
        this.$emit("next", this.$data);
        console.log(this.$data);
      },
      doubleNext() {
        this.$emit("doublenext", this.$data);
      },
    },
    mounted: function () {
      var self = this;
      console.log('this link: ', self.link)
      if ( self.link ) {
        let account_id = self.link;
        setTimeout(function(){
          console.log('verifying link!');
        $.ajax({
            type: "POST",
            url: "/api/rn/verify-link",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({ link: account_id }),
          })
            .done(function (response) {
              console.log("verify link response");
              console.log(response);
              if (response.valid && response.valid == true) {
                console.log('valid link :)');
                MyUtils.setWithExpiry("account_id", response.account_id, 900000);
                MyUtils.setWithExpiry("company_name", response.company_name, 900000);
                self.next();
                self.invalid = false;
              } else {
                console.log('invalid link :/');
                MyUtils.setWithExpiry("account_id", null, 1);
                MyUtils.setWithExpiry("company_name", null, 1);
                // self.next();
                self.invalid = true;
              }
              // self.incrementPage({})
            })
            .fail(function (err) {
              console.log("fail");
              console.log(err.responseText);
              // self.invalid = true;
            });
      },1000);
      }
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .main_container {
    padding-top: 64px;
    margin-left: 8%;
    margin-right: 8%;
    height: 70vh;
  }
  </style>
  